import http from "../clients/http";

export interface OrderStatus {
  id: string;
  name: string;
  description: string;
  color: string;
  step: number;
  isDefault: boolean;
}

export interface StatusTransition {
  current: OrderStatus;
  next: OrderStatus | null;
}

export class OrderStatusService {
  static async getAll(): Promise<OrderStatus[]> {
    const response = await http.get("/order-status");
    return response.data;
  }

  static async getById(id: string): Promise<OrderStatus> {
    const response = await http.get(`/order-status/${id}`);
    return response.data;
  }

  static async getNextStatus(
    currentStatusId: string,
  ): Promise<OrderStatus | null> {
    const response = await http.get(`/order-status/${currentStatusId}/next`);
    return response.data;
  }

  static async getStatusTransitions(): Promise<StatusTransition[]> {
    const response = await http.get("/order-status/transitions");
    return response.data;
  }
}
